import { useEffect, useRef, useState } from 'react'

export const TABLET_WIDTH = 768
export const DESKTOP_WIDTH = 1366
export const DESKTOP_HEIGHT = 768

interface UseMediaQueryProps {
  ref?: React.RefObject<HTMLElement>
}

export const useMediaQuery = ({ ref }: UseMediaQueryProps = {}) => {
  const targetElement = useRef<HTMLElement>(
    ref?.current || document.documentElement
  )

  const [mediaQueryState, setMediaQueryState] = useState(() => {
    const elementWidth = targetElement.current.clientWidth
    return {
      isMobile: elementWidth < TABLET_WIDTH,
      isTablet: elementWidth < DESKTOP_WIDTH && elementWidth >= TABLET_WIDTH,
      isDesktop: elementWidth >= DESKTOP_WIDTH
    }
  })
  const [width, setWidth] = useState(ref?.current?.clientWidth ?? 0)

  useEffect(() => {
    const onResize: ResizeObserverCallback = entries => {
      entries.forEach(entry => {
        const { width, height } = entry.contentRect
        setMediaQueryState({
          isMobile: width < TABLET_WIDTH || height < DESKTOP_HEIGHT,
          isTablet: width < DESKTOP_WIDTH && width >= TABLET_WIDTH,
          isDesktop: width >= DESKTOP_WIDTH && height >= DESKTOP_HEIGHT
        })
        setWidth(width)
      })
    }

    const resizeObserver = new ResizeObserver(onResize)
    resizeObserver.observe(targetElement.current)

    return () => resizeObserver.disconnect()
  }, [ref])

  return {
    isMobile: mediaQueryState.isMobile,
    isTablet: mediaQueryState.isTablet,
    isDesktop: mediaQueryState.isDesktop,
    width
  }
}
